import { Hyperlink } from 'zens-storybook'
import React from 'react'
import { Product } from 'zens-store'
import { StyleSheet } from 'react-native'
import { Link } from 'zens-router'

const styles = StyleSheet.create({
  container: {
    alignSelf: 'flex-start',
  },
})

interface Props {
  companyId: number
  product: Product
}
const ProductWorkspace = (props: Props) => {
  const { companyId, product } = props
  const { workspaceId, workspaceName } = product

  return (
    <Link href={`/companies/${companyId}/workspaces/${workspaceId}`} asChild>
      <Hyperlink style={styles.container} title={workspaceName} />
    </Link>
  )
}

export default ProductWorkspace
